<template>
    <div class="rounded-3xl border-2 border-[#E8E8E8] flex items-center p-2 gap-4 max-h-20 bg-white">
        <div class="rounded-full border-2 border-[#E8E8E8] min-w-10 min-h-10 flex items-center justify-center details uppercase text-valence-primary-500">{{ fileType }}</div>
        <div class="grow mr-2">
            <div class="details mb-1 w-max max-w-48">{{ fileName }}</div>
            <span v-if="fileSize" class="rounded-full border-2 border-[#B8C9FF] bg-[#F0F5FF] details text-valence-primary-500 px-3 py-0.5 whitespace-nowrap">{{ fileSize }}</span>
        </div>
        <button
            v-if="isRemovable"
            type="button"
            :aria-label="`remove ${fileName} attachment`"
            class="border-2 border-[#E8E8E8] rounded-full flex items-center justify-center min-w-6 min-h-6"
            @click="$emit('remove')">
            <i class="bi bi-x icon-bold text-valence-grey-750 leading-none" aria-hidden="true" />
        </button>
    </div>
</template>

<script setup lang="ts">
import type { FileUploadArgs } from "~vue/types/chat";
import { computed } from "vue";

type FileAttachedTagProps = {
    file: File | FileUploadArgs;
    isRemovable?: boolean;
};

const { file, isRemovable = false } = defineProps<FileAttachedTagProps>();

defineEmits<{
    remove: [];
}>();

const fileType = computed(() => {
    const type = file.type;
    if (!type) {
        return "txt";
    }
    return type;
});

const fileName = computed(() => {
    const MAX_FILE_NAME_LENGTH = 30;
    const name = file.name;
    if (name && name.length >= MAX_FILE_NAME_LENGTH) {
        return `${name.slice(0, MAX_FILE_NAME_LENGTH / 2)}...${name.slice(name.length - MAX_FILE_NAME_LENGTH / 2, name.length)}`;
    }
    return name;
});

const fileSize = computed(() => {
    const size = file.size;
    if (!size) {
        return undefined;
    }
    if (size < 1024) {
        return `${size} B`;
    } else if (size < 1024 * 1024) {
        return `${Math.floor(size / 1024)} KB`;
    } else {
        return `${Math.floor(size / 1024 / 1024)} MB`;
    }
});
</script>
